import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

const Home = resolve => require(['@/components/home/Home'], resolve)
const Test = resolve => require(['@/components/test/Test'], resolve)
const Login = resolve => require(['@/components/memberCenter/Login'], resolve)
const Invoice = resolve => require(['@/components/memberCenter/Invoice'], resolve)
const ChangePassword = resolve => require(['@/components/memberCenter/ChangePassword'], resolve)
const CreditsExchange = resolve => require(['@/components/memberCenter/CreditsExchange'], resolve)
const GiftCoupon = resolve => require(['@/components/memberCenter/GiftCoupon'], resolve)
const Information = resolve => require(['@/components/memberCenter/Information'], resolve)
const MyGiftCoupon = resolve => require(['@/components/memberCenter/MyGiftCoupon'], resolve)
const Order = resolve => require(['@/components/memberCenter/Order'], resolve)
const PreviewAccount = resolve => require(['@/components/memberCenter/PreviewAccount'], resolve)
const CouponDetail = resolve => require(['@/components/memberCenter/CouponDetail'], resolve)
const Member = resolve => require(['@/components/memberCenter/Member'], resolve)
const BuyCard = resolve => require(['@/components/memberCenter/BuyCard'], resolve)
const BookingList = resolve => require(['@/components/booking/BookingList'], resolve)
const OrderForm = resolve => require(['@/components/booking/OrderForm'], resolve)
const OrderSuccess = resolve => require(['@/components/booking/OrderSuccess'], resolve)
const OrderDetail = resolve => require(['@/components/booking/OrderDetail'], resolve)
const ModifyPhone = resolve => require(['@/components/memberCenter/ModifyPhone'], resolve)
const SearchHotel = resolve => require(['@/components/booking/SearchHotel'], resolve)
const JumpPage = resolve => require(['@/components/common/JumpPage'], resolve)
const OverTime = resolve => require(['@/components/booking/OverTime'], resolve)
const Activity = resolve => require(['@/components/activity/Activity'], resolve)

const Questions = resolve => require(['@/components/survey/Questions'], resolve)
const TimeOut = resolve => require(['@/components/survey/TimeOut'], resolve)
const AnswerSuccess = resolve => require(['@/components/survey/AnswerSuccess'], resolve)
const Invalid = resolve => require(['@/components/survey/Invalid'], resolve)

Vue.use(Router)

var router = new Router({
	base: "/pc/",
	mode: 'history',
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
		},
		{
			path: '/change-password',
			name: 'changePassword',
			component: ChangePassword,
			meta: {
				title: '修改密码'
			}
		},
		{
			path: '/invoice',
			name: 'invoice',
			component: Invoice,
			meta: {
				title: '我的发票'
			}
		},
		{
			path: '/credits-exchange',
			name: 'creditsExchange',
			component: CreditsExchange,
			meta: {
				title: '积分兑换'
			}
		},
		{
			path: '/gift-coupon',
			name: 'giftCoupon',
			component: GiftCoupon,
			meta: {
				title: '礼券中心'
			}
		},
		{
			path: '/information',
			name: 'information',
			component: Information,
			meta: {
				title: '个人资料完善'
			}
		},
		{
			path: '/my-giftCoupon',
			name: 'myGiftCoupon',
			component: MyGiftCoupon,
			meta: {
				title: '我的礼券'
			}
		},
		{
			path: '/order',
			name: 'order',
			component: Order,
			meta: {
				title: '我的订单'
			}
		},
		{
			path: '/preview-account',
			name: 'previewAccount',
			component: PreviewAccount,
			meta: {
				title: '账户预览'
			}
		},
		{
			path: '/coupon-detail',
			name: 'couponDetail',
			component: CouponDetail,
			meta: {
				title: '礼券详情'
			}
		},
		{
			path: '/member',
			name: 'member',
			component: Member,
			meta: {
				title: '会员权益'
			}
		},
		{
			path: '/buy-card',
			name: 'buyCard',
			component: BuyCard,
			meta: {
				title: '购买会员卡'
			}
		},
		{
			path: '/modify-phone',
			name: 'modifyPhone',
			component: ModifyPhone,
			meta: {
				title: '更换手机号'
			}
		},

		// **********************以上去除会员中心***************************************

		{
			path: '/',
			name: 'searchHotel',
			component: SearchHotel,
			meta: {
				title: '查询酒店'
			}
		},
		{
			path: '/test',
			name: 'test',
			component: Test,
			meta: {
				title: ''
			}
		},
		{
			path: '/booking-list',
			name: 'bookingList',
			component: BookingList,
			meta: {
				title: '房型列表'
			}
		},
		{
			path: '/order-form',
			name: 'orderForm',
			component: OrderForm,
			meta: {
				title: '预订表单'
			}
		},
		{
			path: '/order-success',
			name: 'orderSuccess',
			component: OrderSuccess,
			meta: {
				title: '订单完成'
			}
		},
		{
			path: '/order-detail',
			name: 'orderDetail',
			component: OrderDetail,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/search-hotel',
			name: 'searchHotel',
			component: SearchHotel,
			meta: {
				title: '查询酒店'
			}
		},
		{
			path: '/jump-page',
			name: 'jumpPage',
			component: JumpPage,
		},
		{
			path: '/over-time',
			name: 'overTime',
			component: OverTime,
		},
		{
			path: '/activity',
			name: 'activity',
			component: Activity,
		},
		// 以下是问卷............................................................................
		{
			path: '/questions',
			name: 'questions',
			component: Questions,
			meta: {
				title: '问卷调查'
			}
		},
		{
			path: '/time-out',
			component: TimeOut,
			meta: {
				title: '问卷调查'
			}
		},
		{
			path: '/answer-success',
			component: AnswerSuccess,
			meta: {
				title: '问卷调查'
			}
		},
		{
			path: '/invalid',
			component: Invalid,
			meta: {
				title: '问卷调查'
			}
		}

	]
});

router.afterEach(function (route) {
	window.scrollTo(0, 0);
	if (route.meta.title) {
		document.title = route.meta.title;
	}
	if (route.path == "/preview-account" || route.path == "/information" || route.path == "/invoice" || route.path ==
		"/jump-page") {
		if (localStorage.userJwtToken == undefined) {
			var userJwtToken = getQueryString("userJwtToken");
		} else {
			var userJwtToken = localStorage.userJwtToken
		}
		localStorage.userJwtToken = userJwtToken;
		getTicket(userJwtToken);
		// getAccessToken();
	}
})

router.beforeEach((to, from, next) => {
	// if (_hmt) {
	// 	if (to.path) {
	// 		_hmt.push(['_trackPageview', '/#' + to.fullPath]);
	// 	}
	// }
	getAccessToken();
	setTimeout(() => {
		next();
	}, 500)
})

//query.params
function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return unescape(r[2]);
	}
	return null;
}

function getTicket(userJwtToken) {
	axios.post("/gk/api/token/getTicket?userJwtToken=" + userJwtToken, {}, Vue.prototype.$token).then((res) => {
		if (res.data.status == 200) {
			getUserToken(res.data.data.userTicket)
		}
	}).catch((error) => {
		console.log(error);
	})
}

function getToKen() {
	if (localStorage.accessToken != undefined || localStorage.accessToken != '') {
		Vue.prototype.$token = {
			headers: {
				'accessToken': localStorage.accessToken,
				'userToken': localStorage.userToken,
			}
		};
	} else {
		this.getAccessToken();
	}
}

function getAccessToken() {
	axios.post("/gu/api/v1/hub/auth/getAccessToken").then((res) => {
		localStorage.accessToken = res.data.data.accessToken;
		Vue.prototype.$token = {
			headers: {
				'accessToken': res.data.data.accessToken,
				'userToken': localStorage.userToken,
			}
		};
		getTicket(getQueryString("userJwtToken"))
	}).catch((error) => {
		console.log(error);
	})
}

function getUserToken(params) {
	axios.post("/gk/api/token/getUserToken?ticket=" + params, {}, Vue.prototype.$token).then((res) => {
		Vue.prototype.$token = {
			headers: {
				'accessToken': localStorage.accessToken,
				'userToken': res.data.data.userToken
			}
		};
		localStorage.userToken = res.data.data.userToken;
		sessionStorage.memberId = res.data.data.memberInfo.memberId;
		sessionStorage.memberLevelId = res.data.data.memberInfo.memberLevelId;
		sessionStorage.memberInfo = JSON.stringify(res.data.data.memberInfo);
	}).catch((error) => {
		console.log(error);
	})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js